import React, { useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { BOOKING_URL } from "../utils/constants";
import { COLORS } from "../utils/colors";

const ModalFlex = styled.div`
  display: flex;
  flex-direction: column;
`;
const ModalContainer = styled.section`
  position: fixed;
  background: white;
  width: 100%;
  max-width: 800px;
  min-height: 200px;
  height: auto;
  max-height: 100vh;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  overflow: auto;
`;

const InfoContainer = styled.div`
  padding-top: 20px !important;
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;
`;

const Subheading = styled.h2`
  font-size: 2rem;
  text-align: center;
  color: ${COLORS.primary};
  line-height: 2.1rem;
  padding: 15px 30px 0;
  max-width: 800px;
  margin: 0 auto;
`;

const MovedModal = ({ show, handleClose }) => {
  const handleEscape = useCallback(
    (e) => {
      if (e.key === "Escape" && show) {
        handleClose();
      }
    },
    [show, handleClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [handleEscape]);

  return (
    <div
      className={
        show ? "modal display-block fade-in-fast" : "modal display-none"
      }
    >
      <ModalContainer>
        <ModalFlex>
          <div>
            <div className="align-right">
              <button type="button" onClick={handleClose}>
                <div className="times-margin">
                  <i className="fas fa-times"></i>
                </div>
              </button>
            </div>
            <h1 className="green-text modal-title">Office Relocation</h1>
            <Subheading>
              Returning to Body Dynamic Physical Therapy in Los Gatos and
              taking appointments May 20. Thank you for your patience.
            </Subheading>
          </div>
          <InfoContainer>
            <p style={{ marginBottom: "10px" }}>
              Please call or text us at{" "}
              <a href="tel:4089813456">(408)981-3456</a> or email at{" "}
              <a href="mailto:info@shotdocmd.com">info@shotdocmd.com</a> to get
              in touch.
            </p>
            <p style={{ marginBottom: "20px" }}>
              Online booking is open for appointments starting May 20 at our
              Los Gatos location.
              <br />
              <br />
              Best,
              <br />
              Dr. Kim
            </p>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <Link className="nav-button" to="/contact/directions">
                GET DIRECTIONS
              </Link>
              <a
                className="nav-button"
                href={BOOKING_URL}
                target="_blank"
                rel="noreferrer"
              >
                BOOK NOW
              </a>
            </div>
          </InfoContainer>
        </ModalFlex>
      </ModalContainer>
    </div>
  );
};

export default MovedModal;
